import { useState, useEffect } from 'react';

const KEY = 'fcod_consent';

const applyConsent = (granted) => {
  if (typeof window.gtag === 'function') {
    const v = granted ? 'granted' : 'denied';
    window.gtag('consent', 'update', {
      ad_storage: v, ad_user_data: v, ad_personalization: v, analytics_storage: v,
    });
  }
};

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch { /* storage bloqueado: não exibe */ }
  }, []);

  const choose = (granted) => {
    try { localStorage.setItem(KEY, granted ? 'granted' : 'denied'); } catch { /* ignore */ }
    applyConsent(granted);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[200] p-3 sm:p-4" data-testid="cookie-consent-banner">
      <div className="max-w-3xl mx-auto bg-[#0A2647] border border-[#C5A059]/40 rounded-2xl shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3">
        <p className="text-xs sm:text-sm text-slate-200 leading-relaxed flex-1">
          🍪 Usamos cookies para melhorar sua experiência e medir nossas campanhas, conforme a{' '}
          <span className="text-[#C5A059] font-semibold">LGPD</span>. Cookies essenciais são sempre ativos;
          os de análise e publicidade só com o seu OK.
        </p>
        <div className="flex gap-2 flex-shrink-0">
          <button onClick={() => choose(false)} data-testid="cookie-reject-btn"
            className="px-4 py-2.5 rounded-xl text-xs sm:text-sm font-semibold text-slate-300 border border-white/20 hover:bg-white/10 transition-colors">
            Apenas essenciais
          </button>
          <button onClick={() => choose(true)} data-testid="cookie-accept-btn"
            className="px-5 py-2.5 rounded-xl text-xs sm:text-sm font-bold bg-[#C5A059] text-[#0A2647] hover:bg-[#b8934d] transition-colors">
            Aceitar todos
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
